export * from "/__w/wiggot-web/wiggot-web/packages/web-components/components/input-otp/index.tsx"